<template>
  <div v-wechat-title="title">
    <router-view></router-view>
    <Popup></Popup>
    <Question></Question>
    <Vote></Vote>
    <UserName></UserName>
  </div>
</template>

<script>
import Popup from "../components/wap/Popup";
import Vote from "../components/wap/Vote";
import Question from "../components/wap/Question";
import UserName from "../components/pc/UserName";
import { $subscriber } from "fire-wind-water";
export default {
  name: "Wap",
  data() {
    return {
      isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i),
      webinarInfo: {},
      title: ""
    };
  },
  components: {
    Popup,
    Question,
    UserName,
    Vote
  },
  created() {
    //当前环境是 手机
    if (window.location.href.indexOf("isSetting=1") == -1) {
      if (!this.isMobile) {
        //不是本地
        if (window.location.href.indexOf("local") < 0) {
          if (window.location.href.indexOf("/wap/") > -1) {
            window.$sk.goto(
              window.location.href
                .replace(
                  "29ca13a4a29e0db78321cc6fe87b5ec1",
                  "74033b16de0316e83957a3fc2a529e26"
                )
                .replace("/wap/", "/pc/")
            );
          }
        } else {
          //本地调试
          if (window.location.href.indexOf("/wap/") > -1) {
            window.location.replace(
              window.location.href.replace("/wap/", "/pc/")
            );
          }
        }
      }
    }
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
        this.title = data.title;
        if (window.location.href.indexOf("meetingInfo") == -1) {
          $subscriber.emit("webinarInfo.meeting", data);
        }
      });
    }
  }
};
</script>

<style scoped></style>
